import React, {useEffect, useState} from "react";
import SettingsIconActive from "../../assets/icons/alarm-settings-active.svg";
import DoneIconActive from "../../assets/icons/done-active.svg";
import DoneIconDisabled from "../../assets/icons/done.svg";
import EmailIcon from "../../assets/icons/email.svg";
import BallFilterActiveIcon from "../../assets/icons/filter-ball-active.svg";
import BallIcon from "../../assets/icons/filter-ball.svg";
import FlashIconActive from "../../assets/icons/filter-critcial-active.svg";
import FlagRuIconActive from "../../assets/icons/flag-ru-active.svg";
import GreyLinkIcon from "../../assets/icons/GreyLink.svg";
import LinkIcon from "../../assets/icons/link.svg";
import LogoIconActive from "../../assets/icons/logo-small-active.svg";
import MockHumanIcon from "../../assets/icons/mockMan.png";
import OpenLinkIcon from "../../assets/icons/openLink.svg";
import PhoneIcon from "../../assets/icons/phone.svg";
import BluePlusIcon from "../../assets/icons/plus-svgrepo-blue.svg";
import PlusSvgIcon from "../../assets/icons/plus-svgrepo.svg";
import PlusIcon from "../../assets/icons/plus.svg";
import PotionActiveIcon from "../../assets/icons/potion-active.svg";
import PotionIcon from "../../assets/icons/potion.svg";
import StarIcon from "../../assets/icons/star.svg";
import WebIcon from "../../assets/icons/web.svg";
import TestImage from "../../assets/images/test-image.svg";
import DollarIcon from "../../assets/icons/filter-dollar.svg";
import DollarFilterIconActive from "../../assets/icons/filter-dollar-active.svg";
import IconStarGray from "../../assets/icons/icon-star-gray.svg";
import IconStarActive from "../../assets/icons/icon-star-active.svg";
import {fetchTechonologyOrganiztionData} from "../../helper";
import ApplicationScenarios from "../ApplicationScenarios";
import {SidebarTab} from "../Sidebar";
import "./style.css";
import {
  Container,
  GridContainer,
  IconContainer,
  IconContainerSmall,
  IconWrapper,
  IconWrapperSmall,
  ImageWrapper,
  MinusIcon,
  OpenedDescriptionContainer,
  OpenedDescriptionContent,
  OpenedDescriptionHeading,
  OpenedDescriptionHeadingText,
  Title,
} from "./styles";
import {Tooltip} from "react-tooltip";
import {urlApi, urlMockImageCards} from "../../helper/api";
import {BlockToggleDescriptionTehnology} from "./blockToggleDescriptionTehnology";
import {BlockSkeletonExperts, BlockSkeletonOrganization} from "./BlockSkeleton";

interface InfoExpandProps {
  title: string;
  description?: string;
  image?: string;

  type: SidebarTab;
  data?: any;
  isOpen?: boolean;
}

const InfoExpand: React.FC<InfoExpandProps> = ({
  title,
  description,
  image,
  type,
  data,
  isOpen = false,
}) => {
  const [isDescriptionOpened, setDescriptionOpen] = useState(false);

  const toggleDescription = () => {
    if (!isOpen) {
      setDescriptionOpen(!isDescriptionOpened);
    }
  };

  const renderApplicationScenarios = () => {
    return data?.use_cases.map((item: any) => {
      return <ApplicationScenarios text={item} />;
    });
  };

  const renderVolumeIcons = (
    value: number,
    isTrl: boolean,
    icon: any,
    iconActive: any,
    title: string
  ) => {
    return (
      <IconContainerSmall
        data-tooltip-id={"marketTooltip"}
        data-tooltip-content={title}
        data-tooltip-place="top"
      >
        {[0, 1, 2].map((level) => (
          <IconWrapperSmall key={level}>
            <img
              src={level < value ? iconActive : icon}
              alt={isTrl ? "TRL Icon" : "Potential Volume Icon"}
            />
          </IconWrapperSmall>
        ))}
        <Tooltip id="marketTooltip" className="tooltip" noArrow offset={4} />
      </IconContainerSmall>
    );
  };

  useEffect(() => {
    setDescriptionOpen(isOpen);
  }, [isOpen]);

  return (
    <>
      <Container>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <IconContainer>
            <Title>{title}</Title>
            {data?.potential_volume &&
              renderVolumeIcons(
                data.potential_volume,
                false,
                PotionIcon,
                PotionActiveIcon,
                "Уровень научной зрелости в России (патенты и публикации) за 2023-2026 гг."
              )}
            {data?.trl &&
              renderVolumeIcons(
                data.trl,
                true,
                DoneIconDisabled,
                DoneIconActive,
                "Есть потенциал роста технологии в России"
              )}
            {data?.invest_volume &&
              renderVolumeIcons(
                data.invest_volume,
                true,
                DollarIcon,
                DollarFilterIconActive,
                "Совокупный объем мировых инвестиций в стартапы за 2023-2026 гг."
              )}
            {data?.cagr_tier &&
              renderVolumeIcons(
                data.cagr_tier,
                true,
                BallIcon,
                BallFilterActiveIcon,
                "CAGR"
              )}
            {data?.rank_tier &&
              renderVolumeIcons(
                data.rank_tier,
                true,
                IconStarGray,
                IconStarActive,
                "Rank"
              )}
            {data?.market_forecast_tier &&
              renderVolumeIcons(
                data.market_forecast_tier,
                true,
                DollarIcon,
                DollarFilterIconActive,
                "Прогноз мирового рынка к 2030 г."
              )}

            {/* {data?.trl && renderFIterIcons(data.trl, true)} */}

            {data?.critical && (
              <IconWrapper
                data-tooltip-id={"critical"}
                data-tooltip-content={
                  "Критические и сквозные технологические кластеры в России, согласно Указу Президента РФ от 18.06.2024 № 529"
                }
                data-tooltip-place="top"
              >
                <img src={FlashIconActive} alt="Critical Icon" />
                <Tooltip id="critical" className="tooltip" noArrow offset={4} />
              </IconWrapper>
            )}
            {data?.gpb && (
              <IconWrapper
                data-tooltip-id={"gpb"}
                data-tooltip-content={"Присутствие ГПБ"}
                data-tooltip-place="top"
              >
                <img src={LogoIconActive} alt="Logo Icon" />
                <Tooltip id="gpb" className="tooltip" noArrow offset={4} />
              </IconWrapper>
            )}
            {data?.growth_potential && (
              <IconWrapper
                data-tooltip-id={"potential"}
                data-tooltip-content={"Потенциал роста"}
                data-tooltip-place="top"
              >
                <img src={SettingsIconActive} alt="Growth Potential Icon" />
                <Tooltip
                  id="potential"
                  className="tooltip"
                  noArrow
                  offset={4}
                />
              </IconWrapper>
            )}
            {data?.national && (
              <IconWrapper
                data-tooltip-id={"national"}
                data-tooltip-content={
                  "Есть потенциал роста технологии в России"
                }
                data-tooltip-place="top"
              >
                <img src={FlagRuIconActive} alt="National Icon" />
                <Tooltip id="national" className="tooltip" noArrow offset={4} />
              </IconWrapper>
            )}
          </IconContainer>
          <ImageWrapper onClick={toggleDescription}>
            {isDescriptionOpened ? (
              <MinusIcon />
            ) : (
              <img src={PlusIcon} alt="Toggle icon" />
            )}
          </ImageWrapper>
        </div>
        {isDescriptionOpened && (
          <OpenedDescriptionContainer>
            <OpenedDescriptionHeading>
              <div style={{minWidth: 154, height: 115}}>
                <img
                  src={
                    image
                      ? `${urlApi}/api${image}`
                      : data?.image
                      ? `${urlApi}/api${data?.image}`
                      : urlMockImageCards
                  }
                  alt="Description icon"
                  width={"100%"}
                  height={"100%"}
                />
              </div>
              <OpenedDescriptionHeadingText>
                {description
                  ? description
                  : data?.desc ||
                    "Технологии искусственного интеллекта в здравоохранении имеют потенциал для революции в сфере здравоохранения, обеспечивая более точную диагностику, эффективное лечение, персонализированный подход к пациентам и оптимизацию процессов. Технологии ИИ уже применяются для ранней диагностики рака, прогнозирования сердечно-сосудистых заболеваний, автоматизации медицинских процедури создания новых лекарственных препаратов. Однако, важно отметить,"}
              </OpenedDescriptionHeadingText>
            </OpenedDescriptionHeading>
            {data && data.use_cases && data.use_cases.length ? (
              <OpenedDescriptionContent>
                <Title>СЦЕНАРИИ ПРИМЕНЕНИЯ</Title>
                <GridContainer>{renderApplicationScenarios()}</GridContainer>
              </OpenedDescriptionContent>
            ) : null}

            {/* {data?.technological_advancements && (
            <div style={{color: "white"}}>
              {data?.technological_advancements}
            </div>
          )}
          {data?.swot_analysis && (
            <div style={{color: "white"}}>{data?.swot_analysis}</div>
          )} */}
          </OpenedDescriptionContainer>
        )}
      </Container>
      {data?.cost_and_demand_structure && (
        <BlockToggleDescriptionTehnology
          data={data?.cost_and_demand_structure}
          title={"Структура стоимости и спроса"}
        />
      )}
      {data?.technological_advancements && (
        <BlockToggleDescriptionTehnology
          data={data?.technological_advancements}
          title={"Технологические развития"}
        />
      )}
      {data?.swot_analysis && (
        <BlockToggleDescriptionTehnology
          data={data?.swot_analysis}
          title={"SWOT анализ"}
        />
      )}
    </>
  );
};

export default InfoExpand;

interface OrganizationItemProps {
  title: string;
  description?: string;
  detailLink: string;
  isOpen?: boolean;
}

interface OrganizationProps {
  title: string;
  technologyName: any;
  isOpen?: boolean;
}

const OrganizationItem: React.FC<OrganizationItemProps> = ({
  title,
  description,
  detailLink,
  isOpen = false,
}) => {
  const [isActive, setIsActive] = useState(isOpen);

  const handleToggle = () => {
    setIsActive((prev) => !prev);
  };
  return (
    <div>
      <div
        style={{
          alignItems: "center",
          display: "grid",
          gridTemplateColumns: "25fr 1fr",
          marginTop: "1rem",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "0.5fr 10fr",
            alignItems: "center",
          }}
        >
          <img src={LinkIcon} alt="Link" />
          <Title style={{fontWeight: "700", textTransform: "uppercase"}}>
            {title}
          </Title>
        </div>
        <ImageWrapper
          onClick={handleToggle}
          style={{
            width: "17px",
            height: "17px",
            border: "1px solid #71C6FA",
            borderRadius: "50%",
            margin: "0 auto",
          }}
        >
          {isActive ? (
            <MinusIcon style={{width: "8px", border: "0.75px solid #71C6FA"}} />
          ) : (
            <img src={BluePlusIcon} style={{width: "1rem"}} />
          )}
        </ImageWrapper>
      </div>
      {isActive && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "0.5fr 10fr",
            margin: "0.5rem 0",
          }}
        >
          <div></div>
          <div>
            <div style={{color: "#FFFFFF", lineHeight: "17.9px"}}>
              {description}
            </div>
          </div>
        </div>
      )}
      {detailLink !== null && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "0.5fr 10fr",
            margin: "0.5rem 0",
          }}
        >
          <div></div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              color: "#FFFFFF",
              margin: "0.25rem 0",
            }}
          >
            <img src={OpenLinkIcon} alt="Open link" />
            <a
              target="_blank"
              href={detailLink}
              rel="noreferrer"
              style={{textDecoration: "none", color: "#71C6FA"}}
            >
              Подробнее
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

const OrganizationItemLoader = () => {
  return (
    <BlockSkeletonOrganization />
    // <div
    //   style={{
    //     marginTop: "1rem",
    //     padding: "1rem",
    //     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    //     borderRadius: "8px",
    //     background: "#fff",
    //   }}
    // >
    //   <div
    //     style={{
    //       alignItems: "center",
    //       display: "grid",
    //       gridTemplateColumns: "25fr 1fr",
    //     }}
    //   >
    //     <div
    //       className=""
    //       style={{
    //         display: "grid",
    //         gridTemplateColumns: "0.5fr 10fr",
    //         alignItems: "center",
    //         marginBottom: "10px",
    //       }}
    //     >
    //       <div
    //         className=""
    //         style={{
    //           height: "15px",
    //           width: "15px",
    //           background: "#737DA8",
    //           borderRadius: "4px",
    //         }}
    //       ></div>
    //       <div
    //         className="placeholder-content"
    //         style={{
    //           height: "15px",
    //           width: "250px",
    //           borderRadius: "4px",
    //         }}
    //       ></div>
    //     </div>
    //     <div></div>
    //   </div>
    //   <div
    //     style={{
    //       display: "grid",
    //       gridTemplateColumns: "0.5fr 10fr",
    //       marginTop: "1rem",
    //     }}
    //   >
    //     <div></div>
    //     <div>
    //       <div
    //         className="placeholder-content"
    //         style={{
    //           height: "15px",
    //           width: "450px",
    //           borderRadius: "4px",
    //           marginBottom: "5px",
    //         }}
    //       ></div>
    //       <div
    //         className="placeholder-content"
    //         style={{
    //           height: "15px",
    //           width: "450px",
    //           borderRadius: "4px",
    //           marginBottom: "5px",
    //         }}
    //       ></div>
    //       <div
    //         className="placeholder-content"
    //         style={{
    //           height: "15px",
    //           width: "450px",
    //           borderRadius: "4px",
    //           marginBottom: "5px",
    //         }}
    //       ></div>
    //       <div
    //         className="placeholder-content"
    //         style={{
    //           height: "15px",
    //           width: "250px",
    //           borderRadius: "4px",
    //           marginBottom: "15px",
    //         }}
    //       ></div>
    //       <div
    //         className="placeholder-content"
    //         style={{
    //           height: "20px",
    //           width: "150px",
    //           borderRadius: "4px",
    //           marginBottom: "5px",
    //         }}
    //       ></div>
    //     </div>
    //   </div>
    // </div>
  );
};

const OrganizationInfoExpand: React.FC<OrganizationProps> = ({
  title,
  technologyName,
  isOpen = false,
}) => {
  const [isActive, setIsActive] = useState(isOpen);
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isActive && items.length === 0) {
      setIsLoading(true);
      fetchTechonologyOrganiztionData(technologyName)
        .then((data) => setItems(data))
        .finally(() => setIsLoading(false));
    }
  }, [isActive]);

  const handleToggle = () => {
    setIsActive(!isActive);
  };
  return (
    <Container>
      <IconContainer
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Title>{title}</Title>
        <ImageWrapper
          onClick={handleToggle}
          style={{
            width: "20px",
            height: "20px",
            border: "1px solid #FFFFFF",
            borderRadius: "50%",
          }}
        >
          {isActive ? (
            <MinusIcon style={{margin: "2.5px", width: "10px"}} />
          ) : (
            <img
              src={PlusSvgIcon}
              alt="Open link"
              style={{margin: "2.5px", width: "1.5rem"}}
            />
          )}
        </ImageWrapper>
      </IconContainer>
      {isActive && (
        <>
          {isLoading ? (
            <OrganizationItemLoader />
          ) : (
            <>
              {items.map((item: any, ind) => (
                <OrganizationItem
                  title={item?.name}
                  description={item?.summary}
                  detailLink={item?.webLink}
                  isOpen={ind === 0}
                />
              ))}
              <br />
              <a
                href="https://drti-bkd.sandcloud.ru/"
                target="_blank"
                rel="noreferrer"
                style={{textDecoration: "none"}}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    background: "#4E5574",
                    padding: "0.75rem 1.5rem",
                    margin: "0.5rem 0",
                    borderRadius: "8px",
                  }}
                >
                  <div
                    style={{
                      color: "#ffffff",
                      textDecoration: "uppercase",
                      fontSize: "16px",
                    }}
                  >
                    БОЛЬШЕ КОМПАНИЙ НА ПЛАТФОРМЕ АНАЛИТИКИ
                  </div>
                  <div>
                    <img
                      src={GreyLinkIcon}
                      alt=""
                      style={{bottom: "0.25rem", position: "relative"}}
                    />
                  </div>
                </div>
              </a>
            </>
          )}
        </>
      )}
    </Container>
  );
};

interface ExpertInfoProps {
  title: string;
  isOpen?: boolean;
}
interface ExpertItemProps {
  title: string;
  isOpen?: boolean;
  detailLink?: string;
}

const ExpertItem: React.FC<ExpertItemProps> = ({title, isOpen, detailLink}) => {
  const [isActive, setIsActive] = useState(isOpen);
  const handleToggle = () => {
    setIsActive(!isActive);
  };

  return (
    <div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "0.75fr 5fr 0.25fr",
          alignItems: "center",
          color: "#FFFFFF",
          margin: "10px 0",
        }}
      >
        <img
          src={MockHumanIcon}
          alt="Avatar"
          style={{
            margin: "0 auto",
            width: "44px",
            height: "44px",
            objectFit: "cover",
            borderRadius: "4px",
          }}
        />
        <div style={{lineHeight: "18px"}}>
          <div>
            <img src={StarIcon} alt="" style={{width: "8px", height: "8px"}} />
            <img src={StarIcon} alt="" style={{width: "8px", height: "8px"}} />
            <img src={StarIcon} alt="" style={{width: "8px", height: "8px"}} />
            <img src={StarIcon} alt="" style={{width: "8px", height: "8px"}} />
            <img src={StarIcon} alt="" style={{width: "8px", height: "8px"}} />
          </div>
          <div
            style={{
              fontWeight: "700",
              textTransform: "uppercase",
              fontSize: "15px",
            }}
          >
            Владимир Иванович Щербаков
          </div>
          <div style={{fontSize: "10px"}}>Карточка обновлена 01.04.2026</div>
        </div>
        <ImageWrapper
          onClick={handleToggle}
          style={{
            width: "15px",
            height: "15px",
            border: "1px solid #71C6FA",
            borderRadius: "50%",
            margin: "0 auto",
          }}
        >
          {isActive ? (
            <MinusIcon style={{width: "8px", border: "0.75px solid #71C6FA"}} />
          ) : (
            <img src={BluePlusIcon} style={{width: "1rem"}} />
          )}
        </ImageWrapper>
      </div>
      {isActive && (
        <>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "0.75fr 5fr 0.25fr",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <img
                src={PhoneIcon}
                alt=""
                style={{height: "28px", margin: "2px 0"}}
              />
              <img
                src={EmailIcon}
                alt=""
                style={{height: "28px", margin: "2px 0"}}
              />
              <img
                src={WebIcon}
                alt=""
                style={{height: "28px", margin: "2px 0"}}
              />
            </div>
            <div style={{color: "#FFFFFF"}}>
              <div>
                Эксперт в области инновационной робототехники с многолетним
                опытом разработки и внедрения передовых решений в этой сфере.
                Его работа охватывает широкий спектр технологий, включая
                искусственный интеллект...
              </div>
              {detailLink && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    color: "#FFFFFF",
                  }}
                >
                  <img src={OpenLinkIcon} alt="Open link" />
                  <a
                    href={detailLink}
                    target="_blank"
                    style={{textDecoration: "none", color: "#71C6FA"}}
                  >
                    Подробнее
                  </a>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const ExpertItemLoader = () => {
  return <BlockSkeletonExperts />;
};

const ExpertsInfoExpand: React.FC<ExpertInfoProps> = ({title, isOpen}) => {
  const [isActive, setIsActive] = useState(isOpen);
  const [isLoading, setIsLoading] = useState(false);
  const [items, setItems] = useState([]);
  const handleToggle = () => {
    setIsActive(!isActive);
  };

  useEffect(() => {
    if (isActive && items.length === 0) {
      setIsLoading(true);
      const timeoutId = setTimeout(() => {
        setIsLoading(false);
      }, 2000);

      return () => clearTimeout(timeoutId);
    }
  }, [isActive]);

  return (
    <Container>
      <IconContainer
        style={{
          display: "grid",
          gridTemplateColumns: "5.75fr 0.25fr",
          alignItems: "center",
          color: "rgb(255, 255, 255)",
        }}
      >
        <Title>{title}</Title>
        <ImageWrapper
          onClick={handleToggle}
          style={{
            width: "20px",
            height: "20px",
            border: "1px solid #FFFFFF",
            borderRadius: "50%",
            margin: "0px auto",
          }}
        >
          {isActive ? (
            <MinusIcon style={{margin: "2.5px", width: "10px"}} />
          ) : (
            <img
              src={PlusSvgIcon}
              alt="Open link"
              style={{margin: "2.5px", width: "1.5rem"}}
            />
          )}
        </ImageWrapper>
      </IconContainer>
      {isActive && (
        <>
          {isLoading ? (
            <ExpertItemLoader />
          ) : (
            <>
              <ExpertItem title={"title"} isOpen={true} />
              <ExpertItem title={"title"} isOpen={false} />
              <ExpertItem title={"title"} isOpen={false} />
              <a
                href="https://drti-bkd.sandcloud.ru"
                target="_blank"
                rel="noreferrer"
                style={{textDecoration: "none"}}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    background: "#4E5574",
                    padding: "0.75rem 1.5rem",
                    margin: "0.5rem 0",
                    borderRadius: "8px",
                  }}
                >
                  <div
                    style={{
                      color: "#ffffff",
                      textDecoration: "uppercase",
                      fontSize: "16px",
                    }}
                  >
                    БОЛЬШЕ ЛЮДЕЙ В БАЗЕ ЭКСПЕРТОВ
                  </div>
                  <div>
                    <img
                      src={GreyLinkIcon}
                      alt=""
                      style={{bottom: "0.25rem", position: "relative"}}
                    />
                  </div>
                </div>
              </a>
            </>
          )}
        </>
      )}
    </Container>
  );
};

export {ExpertsInfoExpand, OrganizationInfoExpand};
